import React, { useCallback, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import {makeStyles} from "@mui/styles";
import Header from "../components/dashboard/Header"
import Charts from "../components/dashboard/Charts";
import DashboardData from "../services/dashboard";
import { useNavigate } from "react-router-dom";
import {changeDocumentTitle} from "../lib";

const useStyles = makeStyles(() => ({
  charts: {
    marginTop: 16,
  }
}));

export default function Dashboard() {
  const classes = useStyles();

  const [dashboard, setDashboard] = useState<any>({
    data: [],
    today: {
      InProgress: 0,
      Completed: 0,
      Finished: 0
    }
  });

  const navigate = useNavigate();

  const getDashboardData = useCallback(async () => {
    try {
      const getDashboard = new DashboardData(navigate);
      const response = await getDashboard.inquiry();
      if (!response.data.hasOwnProperty('data') || !response.data.hasOwnProperty('today')) {
        navigate('/app/freight/order') //API 문제발생시 운송주문 페이지로 보냄.
        return
      }

      setDashboard(response.data);
    } catch (e) {
      console.error('failed to handle dashboard:', e);
      navigate('/app/freight/order') //API 문제발생시 운송주문 페이지로 보냄.
    }
  }, [setDashboard])

  useEffect(() => {
    changeDocumentTitle("메인");
    queueMicrotask(getDashboardData);
  }, [])

  return (
    <>
      <Grid container direction={"column"}>
        <Grid item>
          <Header dashboard={dashboard}/>
        </Grid>
        <Grid item className={classes.charts}>
          <Charts dashboard={dashboard}/>
        </Grid>
      </Grid>
    </>
  )
}